// @TODO Alex: move to tt-core
export enum MessagesEnum {
  SUCCEEDED = 'Payment method added',
  PROCESSING = `Processing payment details. We'll update you when processing is complete.`,
  REQUIRES_PAYMENT_METHOD = 'Failed to process payment details. Please try another payment method.',
  ERROR = 'Something went wrong.'
}
